import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ArrowRight, Check, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Quote() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    city: "",
    project_type: "",
    area_m2: "",
    products_interested: "",
    message: "",
  });
  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/quote", form);
      setSuccess(true);
      toast.success(r.data.message || "Teklif talebiniz alındı.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Bir sorun oluştu.");
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="pt-40 pb-24 bg-[#FAFAFA] min-h-screen">
        <div className="max-w-2xl mx-auto px-6 text-center" data-testid="quote-success">
          <div className="w-16 h-16 mx-auto rounded-full bg-[#B8860B]/10 border border-[#B8860B]/30 grid place-items-center text-[#B8860B]">
            <Check size={28} />
          </div>
          <h1 className="mt-6 font-serif-display text-4xl md:text-5xl text-[#1E1E1E]">
            Talebiniz alındı.
          </h1>
          <p className="mt-4 text-[#666]">
            Uzman ekibimiz projenizi inceleyip 24 saat içinde sizinle iletişime geçecek.
          </p>
          <Link to="/urunler" className="btn-ghost mt-10">Ürünlere Göz At</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="quote-page" className="pt-32 pb-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-2 text-[11px] tracking-widest uppercase text-[#888] mb-8">
          <Link to="/" className="hover:text-[#B8860B]">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-[#1E1E1E]">Teklif Al</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="text-[10px] tracking-[0.35em] uppercase text-[#B8860B] mb-4">
              Teklif Alma
            </div>
            <h1 className="font-serif-display text-4xl md:text-6xl text-[#1E1E1E] leading-tight">
              Projeniz için <span className="italic">özel fiyatlandırma.</span>
            </h1>
            <p className="mt-6 text-[15px] text-[#555] leading-relaxed max-w-md">
              Mimari ölçek, m², seçtiğiniz koleksiyonlar ve teslimat lokasyonuna
              göre şeffaf bir teklifi 24 saat içinde iletiyoruz.
            </p>
            <img
              src="/catalog/vesna-hero.jpg"
              alt=""
              className="mt-12 aspect-[4/3] w-full object-cover clip-frame"
            />
          </div>

          <form onSubmit={submit} data-testid="quote-form" className="lg:col-span-7 bg-white p-8 md:p-12 border border-black/5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
              <div>
                <label className="sp-label">Ad Soyad *</label>
                <input required data-testid="q-name" className="sp-input" value={form.name} onChange={on("name")} />
              </div>
              <div>
                <label className="sp-label">E-posta *</label>
                <input required type="email" data-testid="q-email" className="sp-input" value={form.email} onChange={on("email")} />
              </div>
              <div>
                <label className="sp-label">Telefon *</label>
                <input required data-testid="q-phone" className="sp-input" value={form.phone} onChange={on("phone")} />
              </div>
              <div>
                <label className="sp-label">Firma</label>
                <input data-testid="q-company" className="sp-input" value={form.company} onChange={on("company")} />
              </div>
              <div>
                <label className="sp-label">Şehir</label>
                <input data-testid="q-city" className="sp-input" value={form.city} onChange={on("city")} />
              </div>
              <div>
                <label className="sp-label">Proje Tipi</label>
                <select data-testid="q-type" className="sp-input bg-transparent" value={form.project_type} onChange={on("project_type")}>
                  <option value="">Seçiniz</option>
                  <option>Konut</option>
                  <option>Villa</option>
                  <option>Otel</option>
                  <option>Ofis</option>
                  <option>Restoran / Kafe</option>
                  <option>Dış Mekan / Peyzaj</option>
                  <option>Diğer</option>
                </select>
              </div>
              <div>
                <label className="sp-label">Alan (m²)</label>
                <input data-testid="q-area" className="sp-input" value={form.area_m2} onChange={on("area_m2")} />
              </div>
              <div>
                <label className="sp-label">İlgilendiğiniz Ürünler</label>
                <input data-testid="q-products" placeholder="Dolomite, Calacatta..." className="sp-input" value={form.products_interested} onChange={on("products_interested")} />
              </div>
              <div className="md:col-span-2">
                <label className="sp-label">Notunuz</label>
                <textarea data-testid="q-msg" rows={4} className="sp-input resize-none" value={form.message} onChange={on("message")} />
              </div>
            </div>
            <div className="mt-10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
              <p className="text-[11px] text-[#888] max-w-sm">
                Verileriniz KVKK kapsamında güvence altındadır.
              </p>
              <button data-testid="q-submit" disabled={loading} className="btn-gold disabled:opacity-60">
                {loading ? <><Loader2 size={14} className="animate-spin" /> Gönderiliyor</> : <>Teklif İste <ArrowRight size={14} /></>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
